import React, { useState } from "react";
import {
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";

import UploadManually from "../Components/Create/Step2/UploadManually";
import { uploadFileToBucket } from "../Utils";
import axios from "axios";
import { API_URL } from "../Config/secrets";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import UploadFile from "../Components/Create/Step2/UploadFile.jsx";
import { ChevronLeft } from "react-feather";

const arrayFields = ['wholesale_group', "market", "age", "product_category", "target_group", "price", "style", "preferred_market"];

const UploadPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState('1');

  const handleManualUpload = async (data) => {
    try {
      const uploadLogos = async (items, folder) => {
        return Promise.all(items.map(async (item) => {
          let newItem = { ...item };

          arrayFields.forEach((c) => {
            newItem[c] = item[c]?.map((c) => c?.label) || [];
            console.log(newItem[c], item[c])
          })

          if (item.logo) {
            const uploadedLogo = await uploadFileToBucket(`/${folder}`, item.logo);
            newItem.logo = uploadedLogo;
          }

          return newItem;
        }));
      };

      const brands = await uploadLogos(data.brands || [], 'brands-logos');
      const wholesalers = await uploadLogos(data.wholesalers || [], 'wholesalers-logos');
      const retailers = await uploadLogos(data.retailers || [], 'retailers-logos');

      const response = await axios.post(`${API_URL}/company/upload-data-manually`, {
        id: Number(id),
        brands,
        wholesalers,
        retailers
      });

      if (response?.data?.statusCode === 200) {
        navigate('/home');
        toast.success(response?.data?.message);
      }
    } catch (e) {
      toast.error(e?.message || 'Something went wrong');
    }
  };

  const handleFileUpload = async (payload) => {
    try {
      const response = await axios.post(`${API_URL}/company/upload-bulk-data`, { ...payload, companyId: Number(id) });

      return response?.data;
    } catch (e) {
      console.log(e);
      toast.error(e?.message || 'something went wrong')
    }
  };

  return (
    <div className="container">
      <div className="my-3">
        <Button onClick={() => navigate(-1)} color="primary"><ChevronLeft size={18} /> Home</Button>
      </div>
      <h2 className="mb-4">Upload Data</h2>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={`${tab === '1' ? 'active' : ''}`}
            style={{ cursor: 'pointer' }}
            onClick={() => setTab('1')}
          >
            Maunual
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={`${tab === '2' ? 'active' : ''}`}
            style={{ cursor: 'pointer' }}
            onClick={() => setTab('2')}
          >
            File
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={tab}>
        <TabPane tabId="1">
          <UploadManually onSubmit={handleManualUpload} />
        </TabPane>
        <TabPane tabId="2">
          <UploadFile onSubmit={handleFileUpload} />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default UploadPage;
